<template>
  <main role="main" class="main-content" id="justhome">
    <div class="container">
      <section class="jumbotron">
        <div class="row">
          <div class="col-md-9 col-12">
            <h1>Formations <br />pour la filière santé</h1>
            <p>
              Des formations pour tous les acteurs de la filière santé
              (secrétaires, infirmiers, orthoptistes, aides-soignant(e)s...).
            </p>
            <a href="/formations" title="" class="btn btn-primary"
              >Nos formations</a
            >
          </div>
          <div class="d-none d-md-block col-md-3">
            <div class="jumbotron-thumbnail">
              <img src="img/doctor.svg" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section class="home-cards">
        <h2>OFORIS</h2>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card style-red">
              <div class="card-body">
                <h4 class="card-title">C'est quoi ?</h4>
                <p class="card-text">
                  Un organisme de formations dédié aux professionnels de santé.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card style-yellow">
              <div class="card-body">
                <h4 class="card-title">Pourquoi ?</h4>
                <p class="card-text">
                  Garantir l’efficience de nos équipes par des formations
                  techniques hyperspécialisées de qualité.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card style-red">
              <div class="card-body">
                <h4 class="card-title">Pour qui ?</h4>
                <p class="card-text">
                  Tous les acteurs de la filière santé (secrétaires,
                  infirmiers—ières, orthoptistes, aides-soignant(e)s…). Toutes
                  les spécialités sont en développement.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card style-yellow">
              <div class="card-body">
                <h4 class="card-title">Comment ?</h4>
                <p class="card-text">
                  En classe virtuelle. Depuis chez vous, vous vous connectez en
                  temps réel sur une plateforme de réunion pour assister aux
                  cours en direct.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card style-red">
              <div class="card-body">
                <h4 class="card-title">Est-ce pris en charge ?</h4>
                <p class="card-text">
                  Nos formations sont éligibles à des prises en charge. Lorsque
                  vous postulez à une formation, notre équipe vous accompagne
                  dans toutes les démarches administratives auprès de vos
                  organismes de financement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="home-section">
        <div class="row justify-content-md-center">
          <div class="col-md-8 col-lg-9">
            <h2 class="section-title text-center">Fonctionnement</h2>
            <p class="section-description text-center">
              Toutes nos formations se déroulent en classe virtuelle. Nous avons
              établi un processus simple et accessible pour vous.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon">
              <div class="card-body">
                <i class="card-icon icon-account"></i>
                <h3 class="card-title">Créez un compte</h3>
                <p class="card-text">
                  Rejoignez-nous sur Oforis pour consulter nos différents
                  programmes de manières détaillé.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon">
              <div class="card-body">
                <i class="card-icon icon-school"></i>
                <h3 class="card-title">Choisissez votre formation</h3>
                <p class="card-text">
                  Accessible à tous les acteurs de la filière santé.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon">
              <div class="card-body">
                <i class="card-icon icon-date"></i>
                <h3 class="card-title">Préparation</h3>
                <p class="card-text">
                  La semaine précédant la formation, vous recevrez un lien
                  internet vous permettant de rejoindre la réunion ainsi qu'un
                  résumé de cours en format PDF.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon">
              <div class="card-body">
                <i class="card-icon icon-satisfied"></i>
                <h3 class="card-title">C'est parti</h3>
                <p class="card-text">
                  Vous rejoindrez la réunion 15 minutes avant l'heure de début
                  de la formation, qui aura lieu sur la plateforme Cisco Webex.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="home-section">
        <div class="row justify-content-md-center">
          <div class="col-md-8 col-lg-9">
            <h2 class="section-title text-center"></h2>
            <p class="section-description text-center">En 2021</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon" style="max-height: 20vh">
              <div class="card-body">
                <h4 class="card-title text-center">
                  96% de personnes satsfaites
                </h4>
                <p class="card-text">
                  <b-form-rating
                    v-model="4.5"
                    readonly
                    variant="warning"
                  ></b-form-rating>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon" style="max-height: 20vh">
              <div class="card-body">
                <h4 class="card-title text-center">0% d'abandon</h4>
                <p class="card-text text-center" style="padding: 3vh">
                  <b-icon-award-fill
                    scale="3"
                    variant="warning"
                  ></b-icon-award-fill>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon" style="max-height: 20vh">
              <div class="card-body">
                <h4 class="card-title text-center">4 spécialités médicales</h4>
                <p class="card-text text-center" style="padding: 3vh">
                  <b-icon icon="book" variant="info" scale="3"></b-icon>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="card card-icon" style="height: 20vh">
              <div class="card-body">
                <h4 class="card-title text-center">
                  6 médecins et spécialistes formateurs
                </h4>
                <p
                  class="card-text text-center"
                  style="padding-left: 3vh; padding-right: 3vh"
                >
                  <i class="fa fa-stethoscope fa-3x" size="xs"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="card card-icon">
              <div class="card-body">
                <h3 class="card-title text-center">
                  Témoignage de participants
                </h3>
                <div class="row">
                  <div
                    class="col-md-4 col-sm-6 col-xs-12 text-center"
                    style="margin-bottom: 2vh"
                  >
                    Partagez votre expérience
                    <div class="jumbotron-thumbnail">
                      <img
                        src="img/QR code avis google_home page.png"
                        alt=""
                        width="180px"
                        height="180px"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-4 col-sm-6 col-xs-12"
                    style="padding-left: 10vh"
                  >
                    "Formation sur une journée très complète.Support de cours
                    envoyé par mail quelques jours avant la formation ce qui est
                    très pratique cela nous permet de réviser à l'avance."
                    <p class="text-primary">Marie R</p>
                  </div>
                  <div
                    class="col-md-4 col-sm-6 col-xs-12"
                    style="padding-left: 10vh"
                  >
                    "Aspects positifs: Professionnalisme, Qualité.Excellente
                    formation professionnelle en ophtalmologie pour mon équipe
                    et moi même!"
                    <p class="text-primary">Gaëtan G</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="home-section">
        <div class="row justify-content-md-center">
          <div class="col-md-8 col-lg-9">
            <h2 class="section-title text-center">Une question ?</h2>
            <p class="section-description text-center">
              Intéressé par nos formations ? Envie de nous connaître ? Besoin
              d'informations supplémentaires ?
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <a href="/formations" title="" class="card card-icon text-center">
              <span class="card-body text-center">
                <i class="card-icon icon-school"></i>
                <span class="card-title">Consultez nos formations</span>
              </span>
            </a>
          </div>
          <div class="col-md-6 col-xs-12">
            <a href="/contact" title="" class="card card-icon text-center">
              <span class="card-body text-center">
                <i class="card-icon icon-mail"></i>
                <span class="card-title">Contactez-nous</span>
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
import StarRating from "vue-star-rating";
export default {
  name: "home",
  components: {
    StarRating,
  },
  metaInfo() {
    return {
      title: "OFORIS, formations médicales spécialisées",
      meta: [
        {
          name: "description",
          content:
            "Découvrez les formations médicales spécialisées OFORIS ✓En continue ✓Par des experts ✓Certifiées ✓A distance ✓En présentiel ✓Courtes",
        },
        {
          name: "keywords",
          content:
            "Formation médicale,Formation secrétaire médicale à distance,Formation médicale,bayonne,Formation france,Formation à distance,Formation continue,Formation médicale France, Organisme de formation, Formation datadock,Formation qualiopi, Développement professionnel ",
        },
        {
          property: "og:title",
          content: "OFORIS, formations médicales spécialisées",
        },
        { property: "og:site_name", content: "Oforis" },
        { property: "og:type", content: "website" },
      ],
    };
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      publicPath: process.env.BASE_URL,
    };
  },
  components: {},
};
</script>
<style lang="scss">
#justhome {
  background: #fff url("../assets/home-bg.jpg") left 0.1rem top 0rem no-repeat !important;
  background-size: 60% !important;
}
</style>
